import React from 'react';

import { Menu, MenuItem, MenuSeparator } from '@change/ds-core-ui/Menu';
import { EditIcon } from '@change/ds-icons/EditIcon';
import { MoreHorizontalIcon } from '@change/ds-icons/MoreHorizontalIcon';
import { TrashIcon } from '@change/ds-icons/TrashIcon';

import { useI18n } from '@change-corgi/core-react/i18n';

type Props = {
	onEdit?: () => void;
	onRemove?: () => void;
};

export const ActionsMenu: React.FC<Props> = ({ onEdit, onRemove }) => {
	const { translate } = useI18n();

	if (!onEdit && !onRemove) {
		return null;
	}

	return (
		<Menu
			triggerAriaLabel={translate('corgi.petition.starter_dashboard_v2.endorsements.card.menu_aria_label')}
			triggerContent={<MoreHorizontalIcon size="small" />}
			triggerClassName="cursor-pointer"
			contentQaAttribute="endorsement-menu"
		>
			{onEdit && (
				<MenuItem
					key="edit"
					label={translate('corgi.petition.starter_dashboard_v2.endorsements.card.edit_button')}
					leadingIcon={<EditIcon size="small" />}
					onAction={onEdit}
					data-testid="endorsement-menu-edit"
				/>
			)}
			{onEdit && onRemove && <MenuSeparator />}
			{onRemove && (
				<MenuItem
					key="remove"
					label={translate('corgi.petition.starter_dashboard_v2.endorsements.card.remove_button')}
					leadingIcon={<TrashIcon size="small" />}
					onAction={onRemove}
					data-testid="endorsement-menu-remove"
				/>
			)}
		</Menu>
	);
};
